





import { Component, Vue, Prop } from "vue-property-decorator";

/**
 * Modal window component.
 */
@Component
export default class Dialog extends Vue {
	/// Properties
	@Prop({default: "500px"}) width!: string;

	@Prop({default: false}) persistent!: boolean;

	/// Attributes
	show = false;

	/// Methods
	open() {
		// Réinitialisation de la position
		this.show = true;
		this.$emit("open");
	}

	close() {
		this.show = false;
		this.$emit("close");
	}
}
